/**
 * `/zapier-demo-01` — the Zapier step builder.
 *
 * A sibling of ZapierRoutes rather than a child, because it is a separate entry point rather than
 * a second view of the same flow. It shares `/zapier/callback` implicitly: that route is
 * registered with Zapier as an absolute URL, so a connection started from anywhere returns there.
 */
export const ZapierDemo01Routes = {
  path: 'zapier-demo-01',
  handle: { name: 'Zapier step builder', category: 'Zapier' },
  lazy: () => import('../pages/zapier-demo-01'),
};
